module.exports = __webpack_public_path__ + "static/media/filters.47af142a.svg";